import * as React from 'react';
import { inject, observer } from 'mobx-react'
import Helmet from 'react-helmet'
import Header from '../components/Header'
import PrimaryButton from '../components/PrimaryButton'
import './testpage.scss'

import { IRootStore } from '../models/root'

interface ITestPageProps {}

interface InjectedProps extends ITestPageProps {
  store: IRootStore
}

@inject('store')
@observer
class TestPage extends React.Component<ITestPageProps> {
  get injected() {
    return this.props as InjectedProps
  }

  public render () {
    return (
      <div className="page theme--yellow">
        <Helmet title="Test Page" />
        <Header />
        <div className="testpage__content">
          <PrimaryButton text="Throw an error!" callback={this.throwError} />
        </div>
      </div>
    );
  }

  private throwError = () => {
    const { store } = this.injected

    store.throwTopLevelError('You threw an error from the test page!', () => new Promise((resolve, reject) => {
      reject()
    }))

  }
}

export default TestPage;



// WEBPACK FOOTER //
// ./src/pages/testpage.tsx